<template>
    <div class="kr-upload">
        <el-upload
          v-if='addLogoVal!==4'
          action=''
          :auto-upload="false"
          accept="image/jpeg,image/jpg,image/png,image/JPEG,image/JPG,image/PNG"
          :file-list="fileList"
          :show-file-list="false"
          :on-change='changeUpload'>
          <el-button plain>{{uploadText}}</el-button>
        </el-upload>
        <el-upload
          v-else
          action=''
          :auto-upload="false"
          accept="image/jpeg,image/jpg,image/png,image/JPEG,image/JPG,image/PNG"
          :file-list="fileList"
          :show-file-list="false"
          :on-change='changeUpload'>
          <el-button plain class="loginBtn" icon='icon iconfont icon-upload iconColor' type="text">上传登录logo</el-button>
        </el-upload>
        <div class="kr-upload-preview">
            <div class="kr-preview-large" v-show='addLogoVal!==4'>
                <img id="preview-avator" class="preview-avator" width="200px" height="200px" :src="smallImageUrl">
            </div>
            <div v-show='addLogoVal!==4' class="kr-upload-preview-separator"></div>
            <div class="kr-upload-preview-small">
                <div v-show='addLogoVal!==4'>预览</div>
                 <div class="kr-upload-preview-item" :class="{marginTop0:addLogoVal===4}">
                  <div class="img-outer">
                    <img class="preview-small-avator" :style="{width:logoItemsWidth,height:logoItemsHeit}" :src="smallImageUrl">
                  </div>
                  <span v-show='addLogoVal!==4'>{{logoItemsWidth}}*{{logoItemsHeit}}</span>
                </div>
            </div>                       
        </div>
        <div class="kr-upload-tip" style="width: 100%;">
          {{logoItemsName}}
        </div>
    </div>
</template>

<script>
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
export default {
  name: "index",
  props: {
    imgUrl: String,
    imgFile: Object,
    addLogoVal: Number,
    uploadText: {
      type: String,
      default: "点击上传"
    }
  },
  data() {
    return {
      smallImageUrl: this.imgUrl,
      // smallImageUrl: "/static/img/file/personal.png",
      fileList: [],
      cropper: undefined,
      cropperOptions: {
        viewMode: 2,
        dragMode: "move",
        background: false,
        autoCrop: false,
        aspectRatio: 1 / 1,
        preview: document.getElementsByClassName("preview-small-avator"),
        cropend: () => {
          if (this.cropper) {
            this.cropper.getCroppedCanvas().toBlob(blob => {
              if (!blob) {
                return;
              }
              //基于blob创建裁剪后的原生文件
              const raw = new File([blob], this.fileList[0] ? this.fileList[0].name : "cropper.png", { type: blob.type });
              //基于blob创建裁剪后的文件url
              const url = URL.createObjectURL(blob);
              $(".preview-small-avator").attr("src", url);
              const file = {
                url, raw
              };
              if (this.fileList.length) {
                this.fileList[0] = Object.assign({}, this.fileList[0], { ...file });
              }
              this.$emit("onsuccess", file);
            });
          }
        }
      },
      logoItemsName: '',
      logoItemsWidth: '',
      logoItemsHeit: '',
    };
  },
  methods: {
    changeUpload(file, fileList) {
      this.fileList = [];
      if(!/\.(png|jpg|jpeg|PNG|JPEG|JPG)$/.test(file.name)){
        this.$message.error("文件格式必须为png|jpg|jpeg|PNG|JPEG|JPG");
        return;
      }
      if(file.size / 1024  > 500){
        this.$message.error('请上传大小在500KB以内的文件');
        return;
      }
      file.url = URL.createObjectURL(file.raw);
      this.fileList.push(file);
      this.$nextTick(() => {
        let avator = document.getElementById("preview-avator");
        if (this.cropper === undefined) {
          avator.setAttribute("src", file.url);
          this.cropper = new Cropper(avator, this.cropperOptions);
        } else {
          this.cropper.replace(file.url);
        }
        this.smallImageUrl = file.url;
        file.url && $(".preview-small-avator").attr("src", file.url);
        this.$emit("onsuccess", file);
      });
    }
  },
  mounted() {
    if (this.imgUrl) {
      this.cropper = new Cropper(document.getElementById("preview-avator"), this.cropperOptions);
    }
    if(this.addLogoVal){
      if(this.addLogoVal === 1){
        this.logoItemsName = '*仅支持jpg、jpeg、png格式，建议最小尺寸50px*50px';
        this.logoItemsWidth = '50px';
        this.logoItemsHeit = '50px';
      } else if(this.addLogoVal === 2){
        this.logoItemsName = '*仅支持jpg、jpeg、png格式，建议最小尺寸170px*48px';
        this.logoItemsWidth = '170px';
        this.logoItemsHeit = '48px';
      } else if(this.addLogoVal === 3){
        this.logoItemsName = '*仅支持jpg、jpeg、png格式，建议最小尺寸16px*16px';
        this.logoItemsWidth = '16px';
        this.logoItemsHeit = '16px';
      } else {
        this.logoItemsName = '*登录logo的大小为340px*72px，格式必须为png、jpg或jpeg；图片大小不能超过500KB';
        this.logoItemsWidth = '340px';
        this.logoItemsHeit = '72px';
      }
      console.log(this.addLogoVal)
    }
  },
  watch: {
    imgFile: {
      immediate: true,
      handler (file) {
        if (file && file.raw) {
          this.changeUpload(file, [file]);
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.kr-upload {
  .kr-upload-preview {
    margin-top: 12px;
    display: flex;

    .kr-preview-large {
      width: 200px;
      height: 200px;
      background: #e6e9f5;
      color: #e6e9f5;

      > img[src=""],
      > img:not([src]) {
        opacity: 0;
      }
    }

    .kr-upload-preview-separator {
      height: 200px;
      width: 1px;
      background-color: #e6e9f5;
      margin-left: 20px;
      margin-right: 20px;
    }

    .kr-upload-preview-small {
      .kr-upload-preview-item {
        margin-top: 21px;
        display: flex;
        align-items: center;
        overflow: hidden;

        > .img-outer {
          display: flex;
          // border-radius: 50%;
          justify-content: center;
          align-items: center;
          background: #e6e9f5;
          overflow: hidden;
          // > img[src=""],
          // > img:not([src]){
          //   opacity: 0;
          // }
        }

        > span {
          margin-left: 8px;
          color: #9094a3;
          font-size: 12px;
        }
      }
    }
  }

  .kr-upload-tip {
    margin-top: 4px;
    width: 165px;
    color: #9094a3;
    font-size: 12px;
    line-height: 18px;
  }

  .loginBtn {
    font-size: 13px;
    color: #525975;
    border: 0;

    &:hover {
      color: $color-hover-primary;
    }
  }

  .iconColor {
    color: #9da2b3;
  }

  .marginTop0 {
    margin-top: 0 !important;
  }
}
</style>
